// @flow

import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { dateTime } from '../Shared/timeutils'
import SubHeader from '../Shared/Display/SubHeader'
import DateTimeFilter from '../Shared/Buttons/DateTimeFilter'
import CustomFilter from '../Shared/Buttons/CustomFilter'
import ContentList from '../Shared/Data/ContentList'
import ActivityList from '../Shared/Data/ActivityList'
import TopFolders from '../Shared/Data/TopFolders'
import { fetchAdminDetails } from '../Redux/Actions/Details'
import BackArrow from '../Shared/Icons/icon-backarrow-grey.svg'
import './AdminDetails.css'
import { componentCreated, updateDateFilter } from '../Redux/Actions/DateFilter'
import { useLocation, useNavigate } from 'react-router'
import { composeFilterString, getDateFilter, getGroupFilter, processDate, processGroup } from '../utils/analytics-utils'
import { addQuery } from '../utils/router-utils'

function AdminDetails () {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const id = useSelector(state => state.account.ID)
  const data = useSelector(state => state.details.admin)
  const dateFilterStore = useSelector(state => state.dateFilter)
  const name = 'AdminDetails'

  let dateFilterFromStore = getDateFilter(dateFilterStore, name)
  dateFilterFromStore = dateFilterFromStore ? dateFilterFromStore.dateFilter || 'Week' : 'Week'
  const [dateFilter, setDateFilter] = useState(dateFilterFromStore)

  const groupFilter = getGroupFilter(dateFilterStore, name) || ''
  const dateInterval = dateFilter ? dateFilter.dateInterval || null : null

  useEffect(() => {
    dispatch(componentCreated(name))
  }, [])

  useEffect(() => {
    if (id) {
      update(processDate(dateFilter, id), processGroup(groupFilter), id)
    }
  }, [])

  useEffect(() => {
    newQuery(location.search.substring(1).split('&'))
  }, [])

  const newQuery = (query) => {
    const qobj = {}
    let newDateFilter
    query.forEach((q) => {
      qobj[q.split('=')[0]] = q.split('=')[1]
    })
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }
    update(processDate(newDateFilter), processGroup(groupFilter), id)
  }

  const update = (date, group, newID) => {
    const ID = newID || id
    const searchQ = location.search.substring(1).split('&')
    searchQ.forEach((q) => {
      searchQ[q.split('=')[0]] = q.split('=')[1]
    })
    dispatch(fetchAdminDetails(ID, date.start.toISOString(), date.end.toISOString(), searchQ.id))
  }

  const changeDateFilter = (newFilter, isCustom) => {
    if (isCustom) {
      dispatch(updateDateFilter(name, 'Custom', newFilter))
    } else {
      dispatch(updateDateFilter(name, newFilter))
    }
    const f = `${composeFilterString(groupFilter.profiles, groupFilter.groups)}_${groupFilter.alt || ''}`
    addQuery({ date: newFilter, filter: f }, location, navigate)
    setDateFilter(newFilter)
    if (newFilter !== 'Custom') {
      update(processDate(newFilter), processGroup(groupFilter))
    }
  }

  if (data.name) {
    return (
      <div>
        <div className='toolbar'>
          <Link to={'/admin'}>
            <img src={BackArrow} className='interactive' alt='back' />
          </Link>
          <div className='subTitle'>
            <h2>{data.name}</h2>
            <SubHeader type='AdminDetails' />
          </div>
          <div className='adminDateFilter'><DateTimeFilter filterBy={changeDateFilter} currentFilter={dateFilter} /></div>
          <div />
        </div>
        {(dateFilter !== 'Day' && dateFilter !== 'Week' && dateFilter !== 'Month') ? <CustomFilter filterBy={changeDateFilter} currentFilter={dateFilter} /> : ''}
        <div className='UserContent ContentContainer'>
          <div className='col1'>
            <ActivityList data={data.recentActivity} />
            <div className='box'><h4>{dateTime(data.lastLogin)}<span className='pushRight'>LAST LOGIN</span></h4></div>
            <TopFolders
              data={data.recentFoldersAdded}
              alt='AdminDetails'
            />
          </div>
          <div className='col2'>
            <ContentList
              groupFilter={processGroup(groupFilter)}
              data={data.recentContentAdded}
              type='ViewsDuration'
              alt='AdminDetails'
              title='Last Content Added'
            />
            <div className='box'><h4><h3>{data.totalContentAdded}</h3><span className='pushRight'>TOTAL CONTENT ADDED</span></h4></div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div>
      <div className='toolbar'>
        <Link to={'/admin'}>
          <img src={BackArrow} className='interactive' alt='back' />
        </Link>
        <div className='subTitle'>
          <h2>Loading</h2>
          <SubHeader type='AdminDetails' />
        </div>
        <div className='adminDateFilter'><DateTimeFilter filterBy={changeDateFilter} currentFilter={dateFilter} /></div>
        <div />
      </div>
      <div className='UserContent ContentContainer' />
    </div>
  )
}

export default AdminDetails
